import React, { useState, useEffect } from "react";
import classes from "./AppointmentItem.module.scss";
import { useUserState } from "../../../providers/UserProvider";

function AppointmentItem({
  onClick,
  image,
  name,
  specialty,
  onlineMembers,
  item,
}) {
  const user = useUserState();
  const [isOnline, setIsOnline] = useState(false);
  let userType = user.user_login?.approve;

  useEffect(() => {
    if (userType && userType === "user" && onlineMembers) {
      let onlineItem = onlineMembers.filter(
        (element) => element.id === item.dr_info.doctor_key
      );
      if (onlineItem.length === 1) {
        setIsOnline(true);
      }
    }
    if (userType && userType === "doctor" && onlineMembers) {
      let onlineItem = onlineMembers.filter(
        (element) => element.id === item.user_info.user_key
      );
      if (onlineItem.length === 1) {
        setIsOnline(true);
      }
    }
  }, [item, item?.dr_info?.doctor_key, onlineMembers, userType]);

  const renderCounter = () => {
    switch (userType) {
      case "user":
        if (item && item.dr_info.chat_count !== 0) {
          return (
            <div className={classes.messageCounter}>
              {item.dr_info.chat_count}
            </div>
          );
        }
        break;
      case "doctor":
        if (item && item.user_info.chat_count !== 0) {
          return (
            <div className={classes.messageCounter}>
              {item.user_info.chat_count}
            </div>
          );
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className={classes.mainContainer} onClick={onClick}>
      <div className={classes.imageContainer}>
        {renderCounter()}
        <div
          className={!isOnline ? classes.offlineUser : classes.onlineUser}
        ></div>
        <img src={image} className={classes.userImg} alt="user" />
      </div>
      <div className={classes.textContainer}>
        <p style={{ margin: 0 }}>{name}</p>
        <p style={{ marginTop: 5, marginBottom: 5 }}>{specialty}</p>
        <p style={{ margin: 0 }}>{item.event_list[0].data}</p>
      </div>
    </div>
  );
}

export default AppointmentItem;
